import React from 'react'
import { Tabs } from './Tabs'

// Matches NGNCasesetQuestion's split: stacks when the question's own width is narrow.
const TAB_SPLIT_STYLES = `
.ngn-tab-split { container-type: inline-size; }
.ngn-tab-split-body { display: flex; min-height: 300px; }
.ngn-tab-split-left {
  width: 40%;
  flex-shrink: 0;
  overflow: auto;
  border-right: 1px solid var(--border-subtle);
}
.ngn-tab-split-right { flex: 1 1 auto; min-width: 0; overflow: auto; }
@container (max-width: 700px) {
  .ngn-tab-split-body { flex-direction: column; }
  .ngn-tab-split-left { width: 100%; border-right: none; border-bottom: 1px solid var(--border-subtle); }
}
`

export const TabSplitLayout = ({ question, renderTabs = true, children }) => {
  const hasTabs = renderTabs && question.tabs && question.tabs.length > 0

  if (!hasTabs) return <>{children}</>

  return (
    <div className="ngn-tab-split">
      <style>{TAB_SPLIT_STYLES}</style>
      <div className="ngn-tab-split-body">
        <div className="ngn-tab-split-left p-3">
          {question.stimulus && (
            <div
              className="mb-3"
              style={{ textAlign: 'left' }}
              dangerouslySetInnerHTML={{ __html: question.stimulus }}
            />
          )}
          <Tabs tabs={question.tabs} questionGuid={question.guid} />
        </div>
        <div className="ngn-tab-split-right p-3">
          {children}
        </div>
      </div>
    </div>
  )
}
